// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"632e2d3b","453":"77af3237","607":"1b3e53f4","726":"c944f308"}[chunkId] + ".chunk.js";
};